import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-priority-scale-new',
  templateUrl: './tickets-priority-scale.component.html',
  styleUrls: ['./tickets-priority-scale.component.scss'],
  standalone: false,
})
export class TicketsPriorityScaleComponent {
  @Input() ticket;
}
